<template>
  <div>
    <div class="row">
      <div class="col-6">
        <simple-table title="Keywords"
                      url="/entity/keywords"
                      :columns="tableColumns"
                      :actions="actions"
                      :is-entity="true"
                      @clearScreen="closeViewPanel()"></simple-table>
      </div>
      <div class="col-4" v-if="keyword">
        <card>
          <template slot="header">
            <h4 class="card-title">
              View keyword:
              <button class="btn btn-danger pull-right" @click="closeViewPanel">
                Close
              </button>
            </h4>
          </template>
          <fg-input label="Keyword"
                    type="text"
                    v-model="keyword"
                    :disabled="true"
                    placeholder="Keyword">
          </fg-input>
        </card>
      </div>
    </div>
  </div>
</template>
<script>

import SimpleTable from "../../../components/Beast/Table/SimpleTable.vue";

export default {
  components: {
    SimpleTable,
  },
  data() {
    return {
      keyword: "",
      tableColumns: [
        {
          label: "Keyword",
          minWidth: 150,
          field: "keyword"
        }
      ],
      actions: [
        {
          label: "View",
          icon: "search",
          class: "btn-link text-info",
          action: (item) => {
            this.keyword = item.keyword;
          }
        },
        {
          label: "Delete",
          icon: "times",
          class: "btn-link text-danger",
          key: "keyword",
          delete: true
        }
      ]
    };
  },
  methods: {
    closeViewPanel() {
      this.keyword = "";
    },
  }
};
</script>
<style scoped>
</style>
